/**
 *
 * @param player
 */
const enableKeyboardShortcuts = player => {
  let activeElement;

  document.body.addEventListener('keyup', e => {
    // if ads are playing, ignore all keyboard shortcuts
    if (player.ima && player.ima.controller.sdkImpl.adsActive) {
      return;
    }

    switch (e.code) {
      default:
        // do nothing on other keys
        break;
      case 'Tab':
        if (activeElement) {
          activeElement.classList.remove('aria-tabbed');
        }

        if (
          e.target &&
          (e.target.getAttribute('aria-disabled') === 'false' ||
            e.target.getAttribute('aria-label'))
        ) {
          activeElement = e.target;
          activeElement.classList.add('aria-tabbed');
        }
        break;
      case 'Space':
        if (!activeElement) {
          if (player.paused()) {
            player.play();
          } else {
            player.pause();
          }
        }
        break;
    }
  });

  window.addEventListener('click', e => {
    if (activeElement && e.target !== activeElement) {
      activeElement.classList.remove('aria-tabbed');
      activeElement = null;
    }
  });

  player.on('fullscreenchange', () => {
    if (activeElement) {
      activeElement.focus();
    } else {
      player.focus();
    }
  });
};

export default enableKeyboardShortcuts;
